import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import VSpace from "../common/VSpace"
import { faFolderOpen } from "@fortawesome/pro-solid-svg-icons"

type Props = {
  text: string
}

const LargeFolderIcon = ({text}: Props) => {
  return <div className="overlay">
    <VSpace size="large">
      <FontAwesomeIcon icon={faFolderOpen} size="3x" />
      <span>{text}</span>
    </VSpace>
  </div>
}

export default LargeFolderIcon